var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-layer"},[_c('div',{staticClass:"switch-holder"},[_vm._t("switch-holder"),_c('ToggleSwitch',{attrs:{"layout-part":"layer","layer-id":_vm.layerId}})],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }